import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { getEcards } from '../../reducers/selectors'
import { FormattedMessage, useIntl } from 'react-intl'
import { Button, Grid, Modal, Toast } from 'antd-mobile-v5'
import Cert from '../NewYearCampaign/Cert'
import { buildEcardImgBindItem, getEncodedId } from '../../components/common/utils'
import { useBindEcard } from '../../services/hooks'
import styles from './ClubEacrds.module.css'

/**
 * 本页固定发放的那张脸（40 = CLUB VIP 2024），属 CLUB 独家换面集 `CLUB_VIP_IMAGE_CHANGE`
 * （40/47/51/52/53 + 生肖 VIP 副本）。**只能走 POST /api/ecardImage/binding**：该端点校验
 * VIP level > 0 后写装备位、不落所有权；而 PUT /rebinding 的可得性判据是「已拥有 ∪ level 可用集」，
 * 换面集不在其中，会被静默跳过（接口 200、前端弹成功，但卡面没换）。
 */
const CLUB_ECARD_FACE_ID = 40

const ClubEcards = () => {
  const [checkedCertId, setCheckedCertId] = useState()
  const { formatMessage } = useIntl()
  const { ecards } = useSelector((state) => ({
    ecards: getEcards(state),
  }))
  const { loading: submitLoading, run } = useBindEcard({
    onSuccess: () =>
      Toast.show({
        icon: 'success',
        content: formatMessage({ id: 'club-success' }),
      }),
  })

  const bindingCard = () => {
    if (submitLoading) return
    if (!checkedCertId) {
      Modal.alert({
        title: formatMessage({ id: 'common-errorTitle' }),
        content: formatMessage({ id: 'campaign-noEcardSelected' }),
        confirmText: formatMessage({ id: 'common-close' }),
      })
      return
    }
    // 载荷必须包成数组，字段名是 ecardImgId（不是 rebinding 的 ecardImageId）——见 CLUB_ECARD_FACE_ID 的说明。
    run([buildEcardImgBindItem(checkedCertId, CLUB_ECARD_FACE_ID)])
  }

  return (
    <div className={styles.wrapper}>
      <img src={require('../../assets/images/club/bg1.png')} alt="bg1" className={styles.bg} />
      <div className={styles.bottom}>
        <img src={require('../../assets/images/club/content.png')} alt="bg1" className={styles.content} />
        <div className={styles['bottom-area']}>
          <Ecards onChecked={(id) => setCheckedCertId(id)} ecards={ecards} />
          <Button className={styles['receive-btn']} onClick={bindingCard} loading={submitLoading}>
            <FormattedMessage id="club-receive-btn" />
          </Button>
        </div>
      </div>
    </div>
  )
}

function Ecards({ onChecked, ecards }) {
  const [checkedCertId, setCheckedCertId] = useState()

  return (
    <>
      <p className={styles['cert-loading']}>
        <FormattedMessage id="club-certs-list-title" />
      </p>
      <Grid columns={3} gap={8} className={styles['cert-list']}>
        {ecards.map((ecard) => (
          <Grid.Item key={ecard.uniqueId}>
            <Cert
              ecard={ecard}
              check={(checkedCertId) => {
                setCheckedCertId(checkedCertId)
                onChecked(checkedCertId)
              }}
              checked={checkedCertId === getEncodedId(ecard)}
            />
          </Grid.Item>
        ))}
      </Grid>
    </>
  )
}

export default ClubEcards
